import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { BaseValidator } from '@shared/validators/base-validator';
import { BaseValidationError } from '@shared/validators/validation-error/base-error';
import { TranslationService } from '@core/translation/translation.service';

export class U2BRequiredTrueValidator extends BaseValidator {

    public validationError: BaseValidationError;

    constructor(private _translationKey = 'common.validation.checkCheckbox',
                private _callback?: () => boolean) {
        super();
        this.validationError = new BaseValidationError('required', _translationKey);
    }

    public override get IS_INVALID(): ValidationErrors {
        return {
            required: {
                message: TranslationService.translate(this._translationKey)
            }
        };
    }

    public validate(control: AbstractControl): ValidationErrors | null {
        return Validators.requiredTrue(control) ?
            this.IS_INVALID :
            this.IS_VALID;
    }
}
